var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bbp-popup-info",class:[
    _vm.isRevert && 'bbp-popup-info_bottom',
    !_vm.isRevert && 'bbp-popup-info_top',
    _vm.isLeft && 'bbp-popup-info_left',
    _vm.isTextDefault && 'bbp-popup-info_text-initial'
  ],style:(_vm.popupStyle),on:{"click":_vm.onClick}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29626911","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/BBPPopups/BBPPopupInfo.vue
// module id = null
// module chunks = 